import React, { FunctionComponent } from 'react';
import clsx from 'clsx';
import { Grid, Typography } from '@material-ui/core';
import labelAndPriceStyles from './LabelAndPriceStyles';

export interface ILabelAndTextProps {
  label: string | JSX.Element;
  text: string | JSX.Element;
  boldLabel?: boolean;
  boldText?: boolean;
  isMainText?: boolean;
  dataTest: string;
}

const LabelAndText: FunctionComponent<ILabelAndTextProps> = ({
  label,
  text,
  dataTest,
  boldLabel = false,
  isMainText = true,
  boldText = true,
}) => {
  const styles = labelAndPriceStyles();

  return (
    <Grid
      container={true}
      justifyContent={'space-between'}
      spacing={3}
      className={styles.lineContainer}
      data-test={dataTest}
    >
      <Grid item={true} sm={9} xs={6}>
        <Typography
          className={clsx([
            {
              [styles.listText]: !isMainText,
              [styles.boldLabel]: boldLabel,
            },
          ])}
          data-test={'summary:label'}
        >
          {label}
        </Typography>
      </Grid>
      <Grid item={true} sm={3} xs={6} className={styles.priceContainer} data-test={'summary:text'}>
        <Typography
          className={clsx([
            {
              [styles.listText]: !isMainText,
              [styles.boldLabel]: boldText,
            },
          ])}
        >
          {text}
        </Typography>
      </Grid>
    </Grid>
  );
};

export default LabelAndText;
